export const APP_CONFIG = {
  URL: {
    apiBasePath: `${location.protocol}//${
      location.host.includes("localhost") ? "goalx.me" : location.host
    }/`,
    // apiBasePath: `https://goalx.me/`, // use this for localhost purposes
  },
};

export const getHeaders = () => {
  return {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  };
};
